/* eslint-disable prettier/prettier */
/* eslint-disable max-classes-per-file */
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.fetchingCart = false;
    this.updatingCart = false;
    this.sections = [
      {
        id: 'cart-progress-bar',
        section: 'cart-progress-bar',
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: 'main-cart-footer',
        selector: '.js-contents',
      },
      {
        id: 'main-cart-items',
        section: 'main-cart-items',
        selector: '.js-contents',
      },
    ]

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.init()
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return this.sections;
  }

    /**
   * Use Shopify's Section Rendering API to update cart section contents. https://shopify.dev/api/section-rendering
   */
  updateCart(callback = null) {

  const sectionNamesArray = this.getSectionsToRender().map(section => section.section)
  const sectionNamesString = sectionNamesArray.join(',')

  fetch(`/?sections=${sectionNamesString}`)
    .then(response => {
      return response.text()
    })
    .then(state => {
      const parsedState = JSON.parse(state)

      this.getSectionsToRender().forEach(section => {
        const sectionToUpdate = document.getElementById(section.id)
        const elementToReplace =
          sectionToUpdate.querySelector(section.selector) ||
          sectionToUpdate
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState[section.section],
          section.selector,
        )
      })
      const hidden = document.querySelectorAll('.cart__reload.is-empty')
        if (hidden.length) {
        hidden.forEach(element => {
          element.classList.remove('is-empty')
        })
      }

      const event = new CustomEvent('updatecart')
      window.dispatchEvent(event)
      if (callback) {
        callback()
      }
    })
    .catch(e => {
      console.log(e)
    })
  }

  getCart() {
    this.fetchingCart = true;
    // eslint-disable-next-line no-undef
    const config = fetchConfig('javascript')
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    delete config.headers['Content-Type']

    // eslint-disable-next-line no-undef
    return fetch(`/cart.js`, { ...fetchConfig() })
      .then((response) => response.json())
      .then(
        // eslint-disable-next-line func-names
        function (json) {
          this.cart = json
          this.fetchingCart = false
          return json
        }.bind(this)
      )
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e)
      })
    // .finally(() => {})
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const sectionNamesArray = this.getSectionsToRender().map(section => section.section)
    const sectionNamesString = sectionNamesArray.join(',')
    const body = JSON.stringify({
      line,
      quantity,
      sections: sectionNamesString,
      sections_url: `/cart`
    });
    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => response.json())
      .then((state) => {
        const parsedState = state
        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          const replaceWith = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          if (elementToReplace && replaceWith) {
            elementToReplace.innerHTML = replaceWith
          }

        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
        const cartProgressBar = document.querySelector('cart-progress-bar')
        if (cartProgressBar !== null) {
          cartProgressBar.addRemoveProgressProducts()
        }
        if (parsedState.item_count === 0) {
          // console.log('zero');
        }
        const needToHide = document.querySelectorAll('.cart__reload')
        if (needToHide.length && parsedState.item_count === 0) {
          needToHide.forEach(element => {
            element.classList.add('is-empty')
          })
        }
      }).catch((error) => {
        console.error(error)
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    const section = new DOMParser().parseFromString(html, 'text/html')
    const sectionReplace  = section.querySelector(selector) || section
    return sectionReplace.innerHTML
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items')
    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items')
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }
  }

  init() {
    this.getCart().then((json) => {
      this.cartProgressBar = document.querySelector('cart-progress-bar')
      this.cartProgressBar.updateDataBasedOnCart(json)
      this.cartProgressBar.addRemoveProgressProducts()
    })
  }
}

customElements.define('cart-items', CartItems);

class CartProgressBar extends HTMLElement {
  constructor() {
    super()
    const progressBarData = document.getElementById('progressBarData')
    this.progressBarData = JSON.parse(progressBarData.textContent)
    this.giftLevels = []
    this.levels = {
      notMetThreshold: [],
      metThreshold: [],
    }
    this.giftsInCart = []
    this.cart = null
    this.hasFreeGift = false
    this.fetching = false
    this.updatingCart = false
  }

  setGiftLevels() {
    if (!this.progressBarData) {
      return
    }
    this.giftLevels = this.progressBarData.filter(
      ({ type }) => type === 'level_gift'
    )
  }

  getGiftsInCart() {
    return this.cart.items.filter((item) => {
      return item.properties.Gift && item.properties.Gift === 'Free Gift' 
    }, this)
  }

  totalPriceGiftsInCart() {
    if (this.giftsInCart.length === 0) {
      return 0
    }
    const subtotal = this.giftsInCart.reduce((partialSum, item) => {
      return partialSum + item.line_price
    }, 0)
    return subtotal
  }

  calcCartSubtotals() {
    return this.cart.total_price - this.totalPriceGiftsInCart()
  }

  meetsThreshold(threshold) {
    return threshold < this.calcCartSubtotals()
  }

  // eslint-disable-next-line class-methods-use-this
  hasGiftProperty({ properties }) {
    if (!properties.Gift) {
      return false
    }
    return properties.Gift === 'Free Gift'
  }

  isGiftInCart(itemId) {
    const product = this.cartItems.find(({ id, properties }) => {
      return id === itemId && this.hasGiftProperty({ properties })
    })
    return !!product
  }

  shouldHaveGift() {
    const test = this.progressBarData.some(({ type }) => type === 'level_gift')
    return test
  }

  correctGiftLevelsInCart() {
    return this.giftLevels.length && this.giftsInCart.length
  }

  getGiftsToAddRemove() {
    const itemsToAdd = []
    const itemsToRemove = []
    // eslint-disable-next-line consistent-return
    this.giftLevels.forEach((level) => {
      const { threshold, product } = level
      const meetsThreshold = this.meetsThreshold(threshold)
      const isGiftInCart = this.isGiftInCart(product)
      if (
        (meetsThreshold && isGiftInCart) ||
        (!meetsThreshold && !isGiftInCart)
      ) {
        return null
      }
      if (meetsThreshold && !isGiftInCart) {
        const properties = {
          Gift: 'Free Gift',
        }
        if (level.is_mystery_gift === true) {
          properties._is_mystery_gift = 'true'
        }
        itemsToAdd.push({
          quantity: 1,
          id: level.product,
          properties,
        })
      }
    }, this)
    this.cartItems.forEach((item) => {
      const levelProduct = this.giftLevels.find(
        (level) => level.product === item.variant_id
      )
      if (
        this.hasGiftProperty(item) &&
        levelProduct &&
        !this.meetsThreshold(levelProduct.threshold)
      ) {
        itemsToRemove.push(item)
      }
      if( this.hasGiftProperty(item) && levelProduct === undefined ){
        itemsToRemove.push(item)
      }
    }, this)
    if (!itemsToAdd.length && !itemsToRemove.length) {
      return {
        add: [],
        remove: [],
      }
    }
    return {
      add: itemsToAdd,
      remove: itemsToRemove,
    }
  }

  updateCart() {
    if (!this.cartItems) {
      return
    }
    this.cartItemsDOM.updateCart()
  }

  removeGiftsFromCart(remove) {
    this.updatingCart = true
    const updates = {}
    remove.forEach((item) => {
      updates[item.key] = 0
    })
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates,
      }),
    })
      .then((response) => response.json())
      .then(() => {
        this.updatingCart = false
        this.updateCart()
      })
  }

  addGiftsToCart(add) {
    this.updatingCart = true
    return fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: add,
      }),
    }).then((response) => response.json())
  }

  addRemoveGiftsToCart() {
    this.cartItemsDOM = document.querySelector('cart-items')
    const { add, remove } = this.getGiftsToAddRemove()
    if (!add.length && !remove.length) {
      return
    }
    if (add.length && !remove.length) {
      this.addGiftsToCart(add).then(() => {
        this.updatingCart = false
        this.updateCart()
      })
      return
    }
    if (!add.length && remove.length) {
      this.removeGiftsFromCart(remove)
      return
    }
    this.addGiftsToCart(add).then(() => {
      this.removeGiftsFromCart(remove)
    })
  }

  addRemoveProgressProducts() {
    // console.log('addRemoveProgressProducts')
    this.getCart().then(
      // eslint-disable-next-line func-names
      () => {
        if (this.cart) {
          this.updateDataBasedOnCart(this.cart)
        }
        this.addRemoveGiftsToCart()
      },
      this
    )
  }

  updateDataBasedOnCart(json) {
    this.cart = json
    this.cartItems = this.cart.items
    this.cartItemIds = this.cart.items.map((product) => product.id)
    this.giftsInCart = this.getGiftsInCart()
    this.setGiftLevels()
  }

  getCart() {
    // eslint-disable-next-line no-undef
    const config = fetchConfig('javascript')
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    delete config.headers['Content-Type']

    // eslint-disable-next-line no-undef
    return fetch(`/cart.js`, { ...fetchConfig() })
      .then((response) => response.json())
      .then(
        // eslint-disable-next-line func-names
        function (json) {
          this.updateDataBasedOnCart(json)
        }.bind(this)
      )
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e)
      })
    // .finally(() => {})
  }

  isFreeGiftInCart() {
    this.cartItemsEl = document.querySelector('cart-items')

    if (!this.cartItemsEl) {
      return false
    }
    const {
      dataset: { mysteryGiftCount = '0' },
    } = this.cartItemsEl
    return Number(mysteryGiftCount) > 0
  }
}

customElements.define('cart-progress-bar', CartProgressBar)

class CartDiscountCode extends HTMLElement {
  constructor() {
    super();

    const discountForm = document.querySelector(".cart-sidebar-discount");
    this.applyBtn = document.querySelector("#apply-discount-btn");

    this.submitForm = (event) => {
      this.applyDiscount(event);
    };

    discountForm.addEventListener("submit",  this.submitForm);
    this.applyBtn.addEventListener("click",  this.submitForm);
  }

  applyDiscount(event) {
    event.preventDefault();

    const discountCodeInput = document.querySelector("#discount-code-input");
    const code = discountCodeInput.value.trim();
    const applyBtn = this.applyBtn;

    if(code){
      applyBtn.innerHTML = "Applying <span class='loader'></span>";
      applyBtn.style.pointerEvents = "none";

      var domainName = window.location.hostname;
      var pathAfterDomain = window.location.pathname;
      var newURL = 'https://' + domainName + '/discount/' + discountCodeInput.value + '?redirect=' + pathAfterDomain + '&hasDiscount=true';

      window.location.href = newURL;
    }
  }
}

customElements.define('cart-discount-code', CartDiscountCode);

function checkShowDiscount(){
  const url = window.location.href;

  // Checks if discount code is submitted    
  if (url.indexOf('hasDiscount=true') !== -1) {
    const cartProgressBar = document.querySelector('cart-progress-bar');
    const cartDrawer = document.querySelector('cart-drawer');
    const cartDiscountCodeTag = document.querySelector('cart-discount-code');
    const discountCodeError = document.querySelector("#discount-code-error");
    const applyBtn = document.querySelector("#apply-discount-btn");

    // If Discount Code Tag displays, the code is invalid
    if (cartDiscountCodeTag) {
      discountCodeError.innerHTML = "Please Enter Valid Coupon Code."
      applyBtn.innerHTML = "APPLY";
      applyBtn.style.pointerEvents = "all";
    }

    if (cartProgressBar) {
      setTimeout(function() {
          if(cartDrawer) {
            cartDrawer.openMenuDrawer()
          }
      }.bind(this), 66);
    }
  }
}

checkShowDiscount();
